import {
  Button,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

const AddNoteButton = ({handleClick}) => {
    return(
        <Button
            id="addnote"
            onClick={handleClick}
            variant="contained"
            className="btn-primary"
            startIcon={<AddIcon />}
            sx={{ width: "128px", height: "55px", whiteSpace: "nowrap", '&:focus': {
                  outline: '2px solid #E69C00',
                },textTransform: 'none', fontSize: '15px'}}
        >
            Add Note
        </Button>
    )
}
export default AddNoteButton;